import { render, staticRenderFns } from "./FileEditFormModal.vue?vue&type=template&id=10be9a11&"
import script from "./FileEditFormModal.vue?vue&type=script&lang=js&"
export * from "./FileEditFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports